import { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import UpdateCompanyCaps from './updateCompanyCaps';

class ViewUpdateCompanyCaps extends Component{
    state = {
        componentSteps: [
            {
                title: 'Select Company',
                content: <GetInfo apiLink='companies/getOneCompany/' isAllCompanies />,
                id: 0,
            }, {
                title: 'Service limit ',
                content: <UpdateCompanyCaps />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ViewUpdateCompanyCaps
